import React from 'react';
import { useStore } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Icon } from 'antd';
import Btn from '../../../../../../components/btn';
import { useFormMethods } from '../../../../../../helpers/formManager';
import { actionCreators, sliceKeys } from '../../../../model';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import { useCreateAcceptanceMutation } from '../../../../api/createAcceptance';
import {
  searchParamKeys,
  defaultView,
} from '../../../../shared/configs/searchParams';
import { paths } from '../../../../shared/configs/routing';
import {
  getValuesFromStore,
  mapFormValuesToPayload,
} from '../../../../services/acceptancePayloadMapper';
import { useCheckDesksBusyWithCb } from '../../../../controllers/checkDesksBusy';

const { stateReset } = actionCreators[sliceKeys.createPage];

const {
  fromDate: fromName,
  toDate: toName,
  desks: desksName,
} = fieldNames.main;

const SaveAcceptance = () => {
  const history = useHistory();

  const { handleSubmit } = useFormMethods();

  const { dispatch, getState } = useStore();

  const { check, isLoading: isCheckLoading } = useCheckDesksBusyWithCb();

  const { mutate, isLoading } = useCreateAcceptanceMutation({
    onSuccess: (data, variables) => {
      if (data && data !== 'Error') {
        const searchParams = new URLSearchParams({
          [searchParamKeys.company]: variables[fieldNames.main.companyId],
          [searchParamKeys.acceptance]: data,
          [searchParamKeys.view]: defaultView,
        });

        history.push({ pathname: paths.main, search: searchParams.toString() });

        dispatch(stateReset());
      }
    },
  });

  const onSubmit = async (values) => {
    const payload = mapFormValuesToPayload({
      ...values,
      ...getValuesFromStore(getState()),
    });

    check(
      {
        [fromName]: payload[fromName],
        [toName]: payload[toName],
        [desksName]: payload[desksName],
      },
      () => mutate(payload)
    );
  };

  const loading = isLoading || isCheckLoading;

  return (
    <Btn onClick={handleSubmit(onSubmit)} disabled={loading}>
      <span>Сохранить прием помещений</span>
      <Icon type={loading ? 'loading' : 'check'} style={{ height: '14px' }} />
    </Btn>
  );
};

export default SaveAcceptance;
